module.exports = __webpack_public_path__ + "img/img-skin04.f05bb4da.jpg";